<template>
  <div>
    <el-form ref="messageForm" :model="message" label-width="80px">
      <el-form-item label="留言内容">
        <el-input
          v-model="message.memo"
          type="textarea"
          :maxlength="250"
          :rows="2"
          placeholder="请输入留言内容，限定250个字以内。"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱">
        <el-input
          v-model="message.email"
          placeholder="请输入联系邮箱"
        ></el-input>
      </el-form-item>

        <div
        style="display: flex;justify-content: center;"
        >
          <el-button type="primary" @click="submitForm('messageForm')"
          >提交留言</el-button
        >
        </div>


    </el-form>
  </div>
</template>

<script>
import { createGuestBook } from "@/api/guestBook";

export default {
  data() {
    return {
      message: {
        memo: "",
        email: ""
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const emailRegex = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
          if (!emailRegex.test(this.message.email)) {
            alert("请输入正确的邮箱地址！");
            return false;
          }
          if (this.message.memo.length > 250) {
            alert("留言内容不能超过250个汉字！");
            return false;
          }

          createGuestBook(this.message).then(response => {
            if (response.code === 200) {
              this.message.memo = "";
              this.message.email = "";
              alert("留言提交成功！");
              return true;
            }
            });

          // 处理留言存储到数据库或其他操作
        } else {
          console.log("留言提交失败！");
          return false;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/GuestBook.vue